import { forwardRef } from 'react';

import { TextFieldProps } from '@mui/material';

import { Input as InputStyled } from './input-styles';

const Input = forwardRef<HTMLInputElement, TextFieldProps>((props, ref) => {
  return (
    <InputStyled
      {...props}
      inputRef={ref}
      InputLabelProps={{
        ...props.InputLabelProps,
        sx: {
          '&.MuiInputLabel-shrink': {
            transform: 'translate(14px, -4px) scale(0.75)',
          },
          ...props.InputLabelProps?.sx,
        },
      }}
    />
  );
});

Input.displayName = 'Input';

export default Input;
